module.exports = __webpack_public_path__ + "img/KM202BT.6702ea8e.png";